"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const usa_file_input_1 = __importDefault(require("@uswds/uswds/js/usa-file-input"));
const uswds_react_utils_1 = require("@boozallen-uip/uswds-react-utils");
const __1 = require("..");
const __2 = require("../..");
function FileInput({ accept, children, className, disabled = false, error, hint, id, value, wrongFileTypeErrorMessage, ...props }) {
    const containerRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(() => {
        const containerEl = containerRef.current;
        if (!containerEl)
            return;
        // call USWDS's `on` function to initialize the component
        usa_file_input_1.default.on(containerEl);
        // on dismount, call USWDS's `off` function to cleanup the component
        return () => {
            usa_file_input_1.default.off(containerEl);
        };
    }, []);
    // call USWDS's `enable` or `disable` function when the disabled prop changes
    (0, react_1.useEffect)(() => {
        if (!containerRef.current)
            return;
        const inputEl = containerRef.current.querySelector(`#${id}`);
        if (!inputEl)
            return;
        const disabledState = inputEl.disabled;
        if (disabled === disabledState)
            return;
        // if disabled doesn't already have the right state
        if (disabled)
            usa_file_input_1.default.disable(inputEl);
        else
            usa_file_input_1.default.enable(inputEl);
    }, [disabled]);
    const hintId = `${id}--hint`;
    return ((0, jsx_runtime_1.jsxs)("div", { className: "bah-uswds-file-input", ref: containerRef, children: [(0, jsx_runtime_1.jsx)(__1.Label, { target: id, children: children }), (0, jsx_runtime_1.jsx)(__1.Form.Error, { error: error }), hint ? (0, jsx_runtime_1.jsx)(__2.Hint, { id: hintId, children: hint }) : (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {}), (0, jsx_runtime_1.jsx)("div", { className: "bah-uswds-file-input--wrapper", children: (0, jsx_runtime_1.jsx)("input", { ...props, id: id, accept: accept, "aria-describedby": hint ? hintId : undefined, className: (0, uswds_react_utils_1.createClassString)('usa-file-input', className), name: id, type: "file", "data-errormessage": wrongFileTypeErrorMessage }) })] }));
}
exports.default = FileInput;
